(function () {
  'use strict';

  const USING_FRIDGE       = 'using_fridge';
  const USING_SOMETIMES    = 'using_sometimes';
  const TRIED_STOPPED      = 'tried_stopped';
  const RECEIVED_NOT_USED  = 'received_not_used';
  const NOT_RECEIVED       = 'not_received';

  // Fields that belong to each question (for answer cleanup on path change)
  const QUESTION_FIELDS = {
    q1:       ['q1_status'],
    q2:       ['q2_motivation', 'q2_motivation_other'],
    q3:       ['q3_hesitation', 'q3_hesitation_other'],
    q4a:      ['q4a_stopped_reason', 'q4a_stopped_reason_other'],
    q4b:      ['q4b_not_used_reason', 'q4b_not_used_reason_other'],
    q5:       ['q5_effects', 'q5_effects_other'],
    q6:       ['q6_easy_use'],
    q6b:      ['q6b_mode'],
    q6c:      ['q6c_boost_difference', 'q6c_boost_difference_other'],
    q7:       ['q7_meets_expectations'],
    q9:       ['q9_describe'],
    q11:      ['q11_nps'],
    q12:      ['q12_age', 'q12_household', 'q12_gender', 'q12_frequency'],
    qcontact: [],
  };

  const RADIO_FIELDS = {
    q1:  'q1_status',
    q2:  'q2_motivation',
    q3:  'q3_hesitation',
    q4a: 'q4a_stopped_reason',
    q4b: 'q4b_not_used_reason',
    q6:  'q6_easy_use',
    q6b: 'q6b_mode',
    q6c: 'q6c_boost_difference',
    q7:  'q7_meets_expectations',
    q11: 'q11_nps',
  };

  const TEXTAREA_FIELDS = {
    q9: 'q9_describe',
  };

  class CampaignSurvey {
    constructor(root) {
      this.root = root;
      this.id   = root.dataset.campaignSurvey;

      try {
        this.config = JSON.parse(root.dataset.campaignSurveyConfig || '{}');
      } catch {
        this.config = {};
      }

      this.els = {
        loading:     this._el('Loading'),
        gateError:   this._el('GateError'),
        gateTitle:   this._el('GateTitle'),
        gateText:    this._el('GateText'),
        gateRetry:   this._el('GateRetry'),
        formWrap:    this._el('FormWrap'),
        form:        this._el('Form'),
        btnBack:     this._el('BtnBack'),
        btnNext:     this._el('BtnNext'),
        submitError: this._el('SubmitError'),
        success:     this._el('Success'),
        q6Title:     this._el('Q6Title'),
        q6bTitle:    this._el('Q6bTitle'),
        q6cTitle:    this._el('Q6cTitle'),
        successTitle:this._el('SuccessTitle'),
        successText: this._el('SuccessText'),
      };

      this.rid         = new URLSearchParams(window.location.search).get('rid') || '';
      this.answers     = {};
      this.stepIndex   = 0;
      this._autoTimer  = null;
      this._submitting = false;

      this._init();
    }

    _el(name) {
      return document.getElementById(`KefSurvey${name}-${this.id}`);
    }

    _qEl(qid) {
      return document.getElementById(`kef-survey-${qid}-${this.id}`);
    }

    _qa(selector) {
      return Array.from(this.root.querySelectorAll(selector));
    }

    // ---- Initialization ----

    async _init() {
      if (!this.rid) {
        this._setLoading(false);
        this._showGateError('invalid');
        return;
      }

      this._setLoading(true);

      try {
        const url  = `${this.config.apiBaseUrl}/survey-status?survey_code=${encodeURIComponent(this.config.surveyCode)}&rid=${encodeURIComponent(this.rid)}`;
        const res  = await fetch(url);
        const data = await res.json();
        this._setLoading(false);
        data.status === 'ok' ? this._showForm() : this._showGateError(data.status || 'invalid');
      } catch {
        this._setLoading(false);
        this._showGateError('network_error');
      }
    }

    _setLoading(on) {
      if (this.els.loading) this.els.loading.hidden = !on;
    }

    _showGateError(reason) {
      const msgs = {
        invalid:       { title: 'Lien invalide',       text: "Ce lien de questionnaire n'est pas valide. Veuillez utiliser le lien envoyé par e-mail." },
        expired:       { title: 'Lien expiré',         text: 'Ce lien a expiré. Contactez-nous si vous souhaitez encore participer.' },
        used:          { title: 'Déjà complété',       text: 'Vous avez déjà répondu à ce questionnaire. Merci pour votre participation !' },
        network_error: { title: 'Erreur de connexion', text: 'Impossible de vérifier votre lien. Vérifiez votre connexion et réessayez.', retry: true },
      };

      const m = msgs[reason] || msgs.invalid;
      if (this.els.gateTitle) this.els.gateTitle.textContent = m.title;
      if (this.els.gateText)  this.els.gateText.textContent  = m.text;
      if (this.els.gateRetry) this.els.gateRetry.hidden      = !m.retry;
      if (this.els.gateError) this.els.gateError.hidden      = false;
    }

    _showForm() {
      if (this.els.formWrap) this.els.formWrap.hidden = false;
      this._normalizeOptionLabels();
      this._bindEvents();
      this._showStep(0, 'forward');
    }

    _normalizeOptionLabels() {
      this._qa('.kef-survey__option-label').forEach(label => {
        if (label.querySelector('.kef-survey__option-copy')) return;

        const input = Array.from(label.children).find(el => el.tagName === 'INPUT');
        if (!input) return;

        const copy = document.createElement('span');
        copy.className = 'kef-survey__option-copy';

        let node = input.nextSibling;
        while (node) {
          const next = node.nextSibling;
          copy.appendChild(node);
          node = next;
        }

        if (copy.childNodes.length) label.appendChild(copy);
      });
    }

    // ---- Step sequence ----

    _computeSteps() {
      const q1       = this.answers.q1_status || null;
      const q6bMode  = this.answers.q6b_mode || null;
      const showQ5   = [USING_FRIDGE, USING_SOMETIMES, TRIED_STOPPED].includes(q1);
      const usesProd = [USING_FRIDGE, USING_SOMETIMES].includes(q1);
      const showQ6c  = ['boost', 'alternate'].includes(q6bMode);

      const steps = ['q1'];
      if (!q1) return steps;

      // Not received: just Q1 → contact message → submit
      if (q1 === NOT_RECEIVED) {
        steps.push('qcontact');
        return steps;
      }

      steps.push('q2', 'q3');

      if (q1 === TRIED_STOPPED)     steps.push('q4a');
      if (q1 === RECEIVED_NOT_USED) steps.push('q4b');

      if (showQ5) {
        steps.push('q5', 'q6', 'q6b');
        if (showQ6c) steps.push('q6c');
      }

      if (usesProd) {
        steps.push('q7', 'q9');
      }

      if (showQ5) {
        steps.push('q11');
      }

      steps.push('q12');

      return steps;
    }

    // ---- Collect answers from a question's DOM ----

    _collectStep(qid) {
      const qEl = this._qEl(qid);
      if (!qEl) return;

      // qcontact has no inputs
      if (qid === 'qcontact') return;

      if (qid === 'q5') {
        const checked = Array.from(qEl.querySelectorAll('[name="answers[q5_effects][]"]:checked'));
        this.answers.q5_effects = checked.map(c => c.value);
        const other = qEl.querySelector('[name="answers[q5_effects_other]"]');
        if (other) this.answers.q5_effects_other = other.value || '';
        return;
      }

      if (qid === 'q12') {
        const age  = qEl.querySelector('select[name="answers[q12_age]"]');
        const hh   = qEl.querySelector('select[name="answers[q12_household]"]');
        const gen  = qEl.querySelector('[name="answers[q12_gender]"]:checked');
        const freq = qEl.querySelector('[name="answers[q12_frequency]"]:checked');
        if (age?.value)  this.answers.q12_age       = age.value;
        if (hh?.value)   this.answers.q12_household  = hh.value;
        if (gen)         this.answers.q12_gender     = gen.value;
        if (freq)        this.answers.q12_frequency  = freq.value;
        return;
      }

      if (TEXTAREA_FIELDS[qid]) {
        const ta = qEl.querySelector(`[name="answers[${TEXTAREA_FIELDS[qid]}]"]`);
        if (ta) this.answers[TEXTAREA_FIELDS[qid]] = ta.value || '';
        return;
      }

      const field = RADIO_FIELDS[qid];
      if (!field) return;

      const checked = qEl.querySelector(`[name="answers[${field}]"]:checked`);
      if (checked) this.answers[field] = checked.value;

      const other = qEl.querySelector(`[name="answers[${field}_other]"]`);
      if (other) this.answers[`${field}_other`] = other.value || '';
    }

    // ---- Validate current step ----

    _validateStep(qid) {
      const qEl = this._qEl(qid);
      if (!qEl) return true;

      // qcontact has no required fields
      if (qid === 'qcontact') return true;

      qEl.classList.remove('kef-survey__question--error');
      qEl.querySelectorAll('.kef-survey__field-error').forEach(e => e.remove());

      let valid = true;
      let msg   = 'Veuillez sélectionner une réponse.';

      if (qid === 'q5') {
        if (!this.answers.q5_effects?.length) {
          valid = false;
          msg = 'Veuillez sélectionner au moins une réponse.';
        }
      } else if (qid === 'q12') {
        const age  = qEl.querySelector('select[name="answers[q12_age]"]')?.value;
        const hh   = qEl.querySelector('select[name="answers[q12_household]"]')?.value;
        const gen  = qEl.querySelector('[name="answers[q12_gender]"]:checked');
        const freq = qEl.querySelector('[name="answers[q12_frequency]"]:checked');
        if (!age || !hh || !gen || !freq) {
          valid = false;
          msg = 'Veuillez compléter toutes les informations.';
        }
      } else if (TEXTAREA_FIELDS[qid]) {
        valid = true; // optional
      } else if (RADIO_FIELDS[qid]) {
        if (!this.answers[RADIO_FIELDS[qid]]) {
          valid = false;
        }
      }

      // "Autre" visible text field (required if visible)
      if (valid) {
        qEl.querySelectorAll('.kef-survey__other-wrap').forEach(wrap => {
          if (!wrap.hidden) {
            const inp = wrap.querySelector('input[required]');
            if (inp && !inp.value.trim()) {
              valid = false;
              msg = 'Veuillez préciser votre réponse.';
            }
          }
        });
      }

      if (!valid) {
        qEl.classList.add('kef-survey__question--error');
        const p = document.createElement('p');
        p.className = 'kef-survey__field-error';
        p.textContent = msg;
        qEl.appendChild(p);
        qEl.querySelector('input:not([type="hidden"]):not(:disabled), select, textarea')?.focus({ preventScroll: true });
      }

      return valid;
    }

    // ---- Show a step ----

    _showStep(index, direction) {
      const steps = this._computeSteps();
      const qid   = steps[index];
      if (!qid) return;

      this._syncDynamicCopy();

      // Hide and clear error on current active question
      const prev = this.root.querySelector('.kef-survey__question--active');
      if (prev) {
        prev.classList.remove('kef-survey__question--active', 'kef-survey__question--error');
        prev.querySelectorAll('.kef-survey__field-error').forEach(e => e.remove());
      }

      // Activate new question
      const qEl = this._qEl(qid);
      if (!qEl) return;
      qEl.dataset.direction = direction;
      qEl.classList.add('kef-survey__question--active');

      // Focus first interactive element after animation
      setTimeout(() => {
        const first = qEl.querySelector('input:not([type="hidden"]):not(:disabled), select, textarea');
        first?.focus({ preventScroll: true });
      }, 100);

      this._updateNav(index, steps);
    }

    _syncDynamicCopy() {
      const isTriedStopped = this.answers.q1_status === TRIED_STOPPED;

      this._qa('[data-default-text][data-tried-stopped-text]').forEach(el => {
        if (!el) return;
        const defaultText = el.dataset.defaultText || el.textContent;
        const triedStoppedText = el.dataset.triedStoppedText || defaultText;
        el.textContent = isTriedStopped ? triedStoppedText : defaultText;
      });

      this._qa('[data-default-html][data-tried-stopped-html]').forEach(el => {
        if (!el) return;
        const defaultHtml = el.dataset.defaultHtml || el.innerHTML;
        const triedStoppedHtml = el.dataset.triedStoppedHtml || defaultHtml;
        el.innerHTML = isTriedStopped ? triedStoppedHtml : defaultHtml;
      });
    }

    _updateNav(index, steps) {
      if (this.els.btnBack) {
        this.els.btnBack.hidden = index === 0;
      }
      if (this.els.btnNext) {
        this.els.btnNext.disabled = false;
        // Only show "Envoyer" if we know the path has more than one step (q1 answered)
        // or if q1 is answered and this is genuinely the last step
        const q1Answered = !!this.answers.q1_status;
        const isLast     = index >= steps.length - 1 && (steps.length > 1 || q1Answered);
        this.els.btnNext.textContent = isLast ? 'Envoyer mes réponses' : 'Continuer →';
        this.els.btnNext.dataset.isLast = isLast ? '1' : '';
      }
    }

    // ---- Step navigation ----

    async _nextStep() {
      clearTimeout(this._autoTimer);
      if (this._submitting) return;

      const steps = this._computeSteps();
      const qid   = steps[this.stepIndex];

      this._collectStep(qid);
      if (!this._validateStep(qid)) return;

      const newSteps = this._computeSteps();
      const isLast   = this.stepIndex >= newSteps.length - 1;

      if (isLast) {
        await this._handleSubmit();
      } else {
        this._saveProgress(qid); // fire-and-forget
        this.stepIndex++;
        this._showStep(this.stepIndex, 'forward');
      }
    }

    _prevStep() {
      clearTimeout(this._autoTimer);
      if (this.stepIndex <= 0) return;
      this.stepIndex--;
      this._showStep(this.stepIndex, 'back');
    }

    // ---- Save partial progress (fire-and-forget) ----

    _saveProgress(currentStep) {
      if (!this.config.apiBaseUrl || !this.rid) return;

      fetch(`${this.config.apiBaseUrl}/survey-save-progress`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          survey_code:  this.config.surveyCode,
          rid:          this.rid,
          answers:      this._cleanAnswers(),
          current_step: currentStep,
          page_url:     window.location.href,
        }),
      }).catch(() => {}); // silent fail
    }

    _cleanAnswers() {
      const steps = this._computeSteps();
      const valid = new Set(steps.flatMap(qid => QUESTION_FIELDS[qid] || []));
      const out   = {};
      for (const [k, v] of Object.entries(this.answers)) {
        if (valid.has(k)) out[k] = v;
      }
      return out;
    }

    // ---- "Autre" free-text toggle ----

    _handleOtherToggle(input) {
      const wrapId = input.dataset.revealsWrap;
      if (!wrapId) return;
      const wrap = document.getElementById(wrapId);
      if (!wrap) return;

      if (input.type === 'radio') {
        this._qa(`[name="${input.name}"][data-reveals-wrap]`).forEach(r => {
          const w = document.getElementById(r.dataset.revealsWrap);
          if (w) w.hidden = true;
        });
        if (input.checked) {
          wrap.hidden = false;
          wrap.querySelector('input')?.focus();
        }
      } else {
        wrap.hidden = !input.checked;
      }
    }

    // ---- Events ----

    _bindEvents() {
      if (!this.els.form) return;

      this.els.form.addEventListener('submit', e => e.preventDefault());

      this.els.form.addEventListener('change', e => {
        const t = e.target;

        if (t.dataset.revealsWrap) this._handleOtherToggle(t);

        // Clear error state on change
        const qEl = t.closest('.kef-survey__question');
        if (qEl) {
          qEl.classList.remove('kef-survey__question--error');
          qEl.querySelectorAll('.kef-survey__field-error').forEach(e => e.remove());
        }

        // Auto-advance on radio (not Q12, not "autre", not qcontact)
        if (t.type === 'radio' && !t.dataset.revealsWrap) {
          const steps      = this._computeSteps();
          const currentQid = steps[this.stepIndex];
          if (currentQid && currentQid !== 'q12' && currentQid !== 'qcontact') {
            clearTimeout(this._autoTimer);
            this._autoTimer = setTimeout(() => this._nextStep(), 480);
          }
        }
      });

      this.els.form.addEventListener('keydown', e => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
          e.preventDefault();
          this._nextStep();
        }
      });

      if (this.els.btnNext) {
        this.els.btnNext.addEventListener('click', () => this._nextStep());
      }

      if (this.els.btnBack) {
        this.els.btnBack.addEventListener('click', () => this._prevStep());
      }

      if (this.els.gateRetry) {
        this.els.gateRetry.addEventListener('click', () => {
          if (this.els.gateError) this.els.gateError.hidden = true;
          this._init();
        });
      }
    }

    // ---- Final submit ----

    _getUtm() {
      const p   = new URLSearchParams(window.location.search);
      const utm = {};
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(k => {
        const v = p.get(k); if (v) utm[k] = v;
      });
      return utm;
    }

    async _handleSubmit() {
      this._submitting = true;

      if (this.els.btnNext) {
        this.els.btnNext.disabled = true;
        this.els.btnNext.innerHTML = '<span class="kef-survey__submit-spinner" aria-hidden="true"></span> Envoi…';
      }
      if (this.els.submitError) {
        this.els.submitError.textContent = '';
        this.els.submitError.hidden = true;
      }

      const answers = this._cleanAnswers();

      try {
        const res    = await fetch(`${this.config.apiBaseUrl}/survey-submit`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            survey_code: this.config.surveyCode,
            rid:         this.rid,
            answers,
            page_url:    window.location.href,
            utm:         this._getUtm(),
          }),
        });
        const result = await res.json();

        if (res.ok && result.success) {
          this._showSuccess(answers);
        } else if (result.error === 'already_submitted') {
          if (this.els.formWrap) this.els.formWrap.hidden = true;
          this._showGateError('used');
        } else {
          throw new Error(result.error || 'server_error');
        }
      } catch {
        this._submitting = false;
        if (this.els.btnNext) {
          this.els.btnNext.disabled = false;
          this.els.btnNext.textContent = 'Envoyer mes réponses';
        }
        if (this.els.submitError) {
          this.els.submitError.textContent = 'Une erreur est survenue. Veuillez réessayer.';
          this.els.submitError.hidden = false;
        }
      }
    }

    // ---- Success ----

    _showSuccess(answers) {
      if (this.els.formWrap) this.els.formWrap.hidden = true;

      const q1 = answers.q1_status;
      const nps = Number.parseInt(answers.q11_nps, 10);
      const shouldShowRecommendation = Number.isFinite(nps) && nps > 7;
      const base = this.config.messages?.thankYouBase || 'Merci beaucoup pour votre retour.';

      if (this.els.successTitle) {
        this.els.successTitle.textContent = q1 === NOT_RECEIVED
          ? "Oups, ce n'est pas normal 🤔"
          : 'Merci pour votre retour !';
      }

      if (this.els.successText) {
        if (q1 === NOT_RECEIVED) {
          this.els.successText.innerHTML = 'Écrivez-nous à <a href="mailto:contact@keepeatfresh.co" style="color:inherit;font-weight:700">contact@keepeatfresh.co</a> et on s&apos;en occupe au plus vite.';
        } else if (shouldShowRecommendation) {
          const extra = this.config.messages?.positiveExtra || '';
          this.els.successText.innerHTML = base + (extra ? ' ' + extra : '');
        } else {
          this.els.successText.innerHTML = base;
        }
      }

      if (this.els.success) {
        this.els.success.hidden = false;
        this.els.success.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  document.querySelectorAll('[data-campaign-survey]').forEach(el => new CampaignSurvey(el));
})();
